module.exports = __webpack_public_path__ + "img/type-phone.df304417.svg";